import { render, staticRenderFns } from "./accessRightButton.vue?vue&type=template&id=0219bce2"
import script from "./accessRightButton.vue?vue&type=script&lang=js"
export * from "./accessRightButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports